// extracted by mini-css-extract-plugin
export default {"itemsList":"QuoteList_itemsList__2Cz6u","parentWrapper":"QuoteList_parentWrapper__iEAfP","lrow":"QuoteList_lrow__TWDuP","lrows":"QuoteList_lrows__i3i52"};